// Product images live in the website's public blob container and are stored as
// relative paths. The website prefixes the same base from its own config; a
// catalogue page that could not show a photograph would not be a catalogue.
export const BLOB_BASE = "https://artemisflooring.blob.core.windows.net/product-images/";

/** A stored path is per-segment encoded: the paths contain spaces and slashes. */
export function blobUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  return BLOB_BASE + path.split("/").map(encodeURIComponent).join("/");
}
